import { getParsedCookies } from '@ucheba/utils/helpers/core'
import { authCookieToken } from '@ucheba/utils/constants/core'
import { authActions, authSelectors, authThunks } from '@ucheba/store/auth'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect } from 'react'
import dayjs from '@ucheba/utils/helpers/date/dayjs'
import { setAuthCookie } from '@ucheba/store/auth/bll'
import { useRouter } from 'next/router'

/* Проверка токена в браузере */
export const useAuthOnClient = (skip: boolean): void => {
  const dispatch = useDispatch()
  const isValidToken = useSelector(authSelectors.isValidToken)
  const isAuth = useSelector(authSelectors.isAuth)
  const router = useRouter()

  const validateAuth = useCallback(async () => {
    const parsedCookie = getParsedCookies()
    const tokenString = parsedCookie[authCookieToken]

    if (tokenString && !isValidToken) {
      const res = await dispatch<any>(authThunks.isValidToken({}))

      if (res.payload.id) {
        const date = dayjs().add(30, 'days')
        const token = {
          token: tokenString,
          expiresAt: date.format('YYYY-MM-DD hh:mm:ss'),
        }

        dispatch(authActions.login(token))
        setAuthCookie({ token, sendEvent: false })
      } else {
        dispatch(authActions.logout())
      }
    } else if (tokenString && !isAuth) {
      const date = dayjs().add(30, 'days')

      dispatch(
        authActions.login({
          token: tokenString,
          expiresAt: date.format('YYYY-MM-DD hh:mm:ss'),
        })
      )
    } else if (isAuth && !tokenString) {
      dispatch(authActions.logout())
    }
  }, [isValidToken, isAuth, dispatch])

  // Проверка при изменении маршрута
  useEffect(() => {
    if (!skip) {
      router.events.on('routeChangeComplete', validateAuth)
    }
    return () => router.events.off('routeChangeComplete', validateAuth)
  }, [])

  // Первичная проверка при монтировании компонента
  useEffect(() => {
    if (!skip) {
      const parsedCookie = getParsedCookies()
      const tokenString = parsedCookie[authCookieToken]

      if (tokenString) {
        validateAuth()
      }
    }
  }, [skip])
}
